(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Art-of-Making"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var root = document.querySelector('[data-aom-section]');
    if (!root) return;
    root.classList.add('aom-js');

    var isEditor = !!(window.Shopify && window.Shopify.designMode);
    var animEls = root.querySelectorAll('[data-animate], [data-stagger]');

    if (isEditor) {
      animEls.forEach(function(el) { el.classList.add('aom-in'); });
    } else {
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) { entry.target.classList.add('aom-in'); observer.unobserve(entry.target); }
        });
      }, { threshold: 0.1, rootMargin: '0px 0px -5% 0px' });
      animEls.forEach(function(el) { observer.observe(el); });
      setTimeout(function() {
        animEls.forEach(function(el) { if (!el.classList.contains('aom-in')) el.classList.add('aom-in'); });
      }, 2500);
    }

    root.querySelectorAll('.aom-swatch').forEach(function(swatch) {
      swatch.addEventListener('click', function() {
        var grid = swatch.closest('.aom-swatch-grid');
        openDetail(grid, swatch);
      });
    });

    initProcessCarousel();

    function initProcessCarousel() {
      var row = root.querySelector('.aom-process-row');
      if (!row) return;
      var originals = Array.from(row.querySelectorAll('.aom-process-item'));
      if (originals.length < 2) return;
      var activeRealIdx = 0;
      var isProgrammaticScroll = false;
      var scrollDebounce;
      var rafScheduled = false;
      var clonesAdded = false;

      function isMobile() { return window.matchMedia('(max-width: 900px)').matches; }
      function tagOriginals() { originals.forEach(function(item, i) { item.dataset.realIdx = String(i); }); }

      function addClones() {
        if (clonesAdded) return;
        var first = originals[0];
        var last = originals[originals.length - 1];
        var firstClone = first.cloneNode(true);
        var lastClone = last.cloneNode(true);
        firstClone.classList.add('aom-clone');
        lastClone.classList.add('aom-clone');
        firstClone.setAttribute('aria-hidden', 'true');
        lastClone.setAttribute('aria-hidden', 'true');
        firstClone.dataset.realIdx = '0';
        lastClone.dataset.realIdx = String(originals.length - 1);
        row.insertBefore(lastClone, first);
        row.appendChild(firstClone);
        [firstClone, lastClone].forEach(function(c) {
          c.addEventListener('click', function() {
            if (!isMobile()) return;
            scrollToRealIdx(parseInt(c.dataset.realIdx, 10), true);
          });
        });
        clonesAdded = true;
      }

      function removeClones() {
        row.querySelectorAll('.aom-clone').forEach(function(c) { c.remove(); });
        clonesAdded = false;
      }

      function getAllItems() { return Array.from(row.querySelectorAll('.aom-process-item')); }

      function findRealItem(realIdx) {
        for (var i = 0; i < originals.length; i++) {
          if (parseInt(originals[i].dataset.realIdx, 10) === realIdx) return originals[i];
        }
        return null;
      }

      function getCenteredItem() {
        var all = getAllItems();
        var rowRect = row.getBoundingClientRect();
        var center = rowRect.left + rowRect.width / 2;
        var closest = null, best = Infinity;
        all.forEach(function(t) {
          var r = t.getBoundingClientRect();
          var d = Math.abs(center - (r.left + r.width / 2));
          if (d < best) { best = d; closest = t; }
        });
        return closest;
      }

      function applyState() {
        var all = getAllItems();
        if (!isMobile()) { all.forEach(function(t) { t.classList.remove('aom-dim'); }); return; }
        all.forEach(function(t) {
          var ri = parseInt(t.dataset.realIdx, 10);
          t.classList.toggle('aom-dim', ri !== activeRealIdx);
        });
      }

      function scrollToRealIdx(realIdx, smooth) {
        if (!isMobile()) return;
        var target = findRealItem(realIdx);
        if (!target) return;
        isProgrammaticScroll = true;
        var itemRect = target.getBoundingClientRect();
        var rowRect = row.getBoundingClientRect();
        var targetScroll = row.scrollLeft + itemRect.left - rowRect.left - (rowRect.width - itemRect.width) / 2;
        row.scrollTo({ left: targetScroll, behavior: smooth ? 'smooth' : 'auto' });
        activeRealIdx = realIdx;
        applyState();
        setTimeout(function() { isProgrammaticScroll = false; }, smooth ? 500 : 50);
      }

      function jumpFromCloneToReal(cloneEl) {
        var realIdx = parseInt(cloneEl.dataset.realIdx, 10);
        var real = findRealItem(realIdx);
        if (!real) return;
        isProgrammaticScroll = true;
        var realRect = real.getBoundingClientRect();
        var rowRect = row.getBoundingClientRect();
        var newScroll = row.scrollLeft + realRect.left - rowRect.left - (rowRect.width - realRect.width) / 2;
        row.scrollTo({ left: newScroll, behavior: 'auto' });
        setTimeout(function() { isProgrammaticScroll = false; }, 60);
      }

      row.addEventListener('scroll', function() {
        if (!isMobile() || isProgrammaticScroll) return;
        if (!rafScheduled) {
          rafScheduled = true;
          requestAnimationFrame(function() {
            rafScheduled = false;
            var centered = getCenteredItem();
            if (!centered) return;
            var realIdx = parseInt(centered.dataset.realIdx, 10);
            if (realIdx !== activeRealIdx) { activeRealIdx = realIdx; applyState(); }
          });
        }
        clearTimeout(scrollDebounce);
        scrollDebounce = setTimeout(function() {
          var centered = getCenteredItem();
          if (centered && centered.classList.contains('aom-clone')) jumpFromCloneToReal(centered);
        }, 150);
      });

      originals.forEach(function(item) {
        item.addEventListener('click', function(e) {
          if (!isMobile()) return;
          var ri = parseInt(item.dataset.realIdx, 10);
          if (ri !== activeRealIdx) { e.preventDefault(); scrollToRealIdx(ri, true); }
        });
      });

      function setInitialPosition() {
        if (!isMobile()) { removeClones(); applyState(); return; }
        addClones();
        requestAnimationFrame(function() {
          requestAnimationFrame(function() { scrollToRealIdx(0, false); });
        });
      }

      tagOriginals();
      setInitialPosition();

      var lastIsMobile = isMobile();
      window.addEventListener('resize', function() {
        var nowMobile = isMobile();
        if (nowMobile !== lastIsMobile) { lastIsMobile = nowMobile; setInitialPosition(); }
      });
    }

    function buildInnerHTML(d) {
      var photoHTML = d.img
        ? '<img class="aom-detail-photo" src="' + d.img + '" alt="' + d.name + '" loading="lazy">'
        : '<div class="aom-detail-photo ' + d.cls + '"></div>';
      var careCleanText = d.careClean || '';
      var careAvoidText = d.careAvoid || '';
      var careLongText = d.careLong || '';

      return '<button type="button" class="aom-panel-close" data-aom-close aria-label="Close">×</button>' +
        '<div class="aom-content-stage">' +
        '<div class="aom-detail-inner">' +
          '<div class="aom-detail-photo-wrap">' + photoHTML + '</div>' +
          '<div class="aom-text-stage">' +
            '<div class="aom-text-panel aom-text-panel--front">' +
              '<button type="button" class="aom-detail-close" data-aom-close>Close</button>' +
              '<span class="aom-detail-eyebrow">' + d.label + '</span>' +
              '<div class="aom-detail-name">' + d.name + '</div>' +
              '<p class="aom-detail-desc">' + d.desc + '</p>' +
              '<div class="aom-detail-specs">' +
                '<div><div class="aom-spec-label">Origin</div><div class="aom-spec-value">' + d.origin + '</div></div>' +
                '<div><div class="aom-spec-label">Finish</div><div class="aom-spec-value">' + d.finish + '</div></div>' +
                '<div><div class="aom-spec-label">Thickness</div><div class="aom-spec-value">' + d.thickness + '</div></div>' +
                '<div><div class="aom-spec-label">Best For</div><div class="aom-spec-value">' + d.best + '</div></div>' +
              '</div>' +
              '<button type="button" class="aom-nav-btn aom-nav-btn--forward" data-aom-flip>Care Guide<span class="aom-arrow"></span></button>' +
            '</div>' +
            '<div class="aom-text-panel aom-text-panel--back">' +
              '<button type="button" class="aom-detail-close" data-aom-close>Close</button>' +
              '<span class="aom-detail-eyebrow">Care Guide &middot; ' + d.name + '</span>' +
              '<div class="aom-detail-name">How to care</div>' +
              '<div class="aom-care-blocks">' +
                '<div class="aom-care-block">' +
                  '<span class="aom-care-label">How to clean</span>' +
                  '<p class="aom-care-text">' + careCleanText + '</p>' +
                '</div>' +
                '<div class="aom-care-block">' +
                  '<span class="aom-care-label">Avoid</span>' +
                  '<p class="aom-care-text">' + careAvoidText + '</p>' +
                '</div>' +
                '<div class="aom-care-block">' +
                  '<span class="aom-care-label">Long-term care</span>' +
                  '<p class="aom-care-text">' + careLongText + '</p>' +
                '</div>' +
              '</div>' +
              '<button type="button" class="aom-nav-btn aom-nav-btn--back" data-aom-unflip>Back to Details<span class="aom-arrow"></span></button>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>';
    }

    function wirePanelHandlers(panel, clickedSwatch) {
      var stage = panel.querySelector('.aom-text-stage');
      var frontPanel = panel.querySelector('.aom-text-panel--front');
      var backPanel = panel.querySelector('.aom-text-panel--back');

      function measurePanelHeight(target) {
        if (!target) return 0;
        var prevPos = target.style.position;
        var prevVis = target.style.visibility;
        target.style.position = 'relative';
        target.style.visibility = 'hidden';
        var h = target.offsetHeight;
        target.style.position = prevPos;
        target.style.visibility = prevVis;
        return h;
      }

      function updateStageHeight() {
        if (!frontPanel || !backPanel || !stage) return;
        var isFlipped = stage.classList.contains('aom-flipped');
        var target = isFlipped ? backPanel : frontPanel;
        var h = measurePanelHeight(target);
        stage.style.minHeight = h + 'px';
      }
      setTimeout(updateStageHeight, 60);
      panel._updateStageHeight = updateStageHeight;

      panel.querySelectorAll('[data-aom-flip]').forEach(function(btn) {
        btn.addEventListener('click', function(e) {
          e.stopPropagation();
          stage.classList.add('aom-flipped');
          updateStageHeight();
        });
      });
      panel.querySelectorAll('[data-aom-unflip]').forEach(function(btn) {
        btn.addEventListener('click', function(e) {
          e.stopPropagation();
          stage.classList.remove('aom-flipped');
          updateStageHeight();
        });
      });
      panel.querySelectorAll('[data-aom-close]').forEach(function(btn) {
        btn.addEventListener('click', function(e) {
          e.stopPropagation();
          clickedSwatch.classList.remove('aom-active');
          panel.classList.remove('aom-open');
          panel.classList.add('aom-closing');
          panel.style.maxHeight = '0';
          panel.style.opacity = '0';
          panel.style.marginTop = '-40px';
          panel.style.marginBottom = '-40px';
          setTimeout(function() {
            if (panel._updateStageHeight) {
              window.removeEventListener('resize', panel._updateStageHeight);
            }
            panel.remove();
          }, 350);
        });
      });
      window.addEventListener('resize', updateStageHeight);
    }

    function openDetail(grid, clickedSwatch) {
      var d = clickedSwatch.dataset;
      var existing = grid.querySelector('.aom-detail-panel');

      if (existing && existing.classList.contains('aom-closing')) { existing.remove(); existing = null; }

      grid.querySelectorAll('.aom-swatch').forEach(function(s) { s.classList.remove('aom-active'); });
      clickedSwatch.classList.add('aom-active');

      if (existing) {
        var stage = existing.querySelector('.aom-content-stage');
        if (stage) {
          var swatchesArr = Array.from(grid.querySelectorAll('.aom-swatch'));
          var idx = swatchesArr.indexOf(clickedSwatch);
          var colCount = getComputedStyle(grid).gridTemplateColumns.split(' ').length;
          var rowEnd = Math.min(Math.floor(idx / colCount) * colCount + colCount - 1, swatchesArr.length - 1);
          if (existing.previousElementSibling !== swatchesArr[rowEnd]) {
            swatchesArr[rowEnd].insertAdjacentElement('afterend', existing);
          }
          stage.classList.add('aom-swapping');
          setTimeout(function() {
            if (existing._updateStageHeight) {
              window.removeEventListener('resize', existing._updateStageHeight);
            }
            existing.innerHTML = buildInnerHTML(d);
            wirePanelHandlers(existing, clickedSwatch);
            var newStage = existing.querySelector('.aom-content-stage');
            newStage.classList.add('aom-swapping');
            newStage.offsetHeight;
            requestAnimationFrame(function() { newStage.classList.remove('aom-swapping'); });
          }, 420);
          return;
        }
      }

      var panel = document.createElement('div');
      panel.className = 'aom-detail-panel';
      panel.style.cssText = 'grid-column: 1 / -1; overflow: hidden; max-height: 0; opacity: 0; margin-top: -40px; margin-bottom: -40px; transition: max-height 0.7s cubic-bezier(0.22, 1, 0.36, 1), opacity 0.5s cubic-bezier(0.22, 1, 0.36, 1), margin-top 0.7s cubic-bezier(0.22, 1, 0.36, 1), margin-bottom 0.7s cubic-bezier(0.22, 1, 0.36, 1) !important; background: #F7F7F5; position: relative;';
      panel.innerHTML = buildInnerHTML(d);

      var swatches = Array.from(grid.querySelectorAll('.aom-swatch'));
      var index = swatches.indexOf(clickedSwatch);
      var cols = getComputedStyle(grid).gridTemplateColumns.split(' ').length;
      var rowEndIndex = Math.min(Math.floor(index / cols) * cols + cols - 1, swatches.length - 1);
      swatches[rowEndIndex].insertAdjacentElement('afterend', panel);

      requestAnimationFrame(function() {
        requestAnimationFrame(function() {
          panel.style.maxHeight = '2000px';
          panel.style.opacity = '1';
          panel.style.marginTop = '0';
          panel.style.marginBottom = '0';
          panel.classList.add('aom-open');
        });
      });
      wirePanelHandlers(panel, clickedSwatch);

      setTimeout(function() { panel.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); }, 400);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
